import useGetUserNewspaper from './useGetUserNewspaper'

export default useGetUserNewspaper
